module.exports = __webpack_public_path__ + "img/customer_tag_2.a569b9a5.png";